/**
 * Returns a mock auth-user when running in dev-mode with ?test=1.
 * In production-build, import.meta.env.DEV is false → entire block
 * tree-shaken away. Cannot leak into production.
 *
 * Accepts an optional ?role=<role> param (default: 'owner') so E2E
 * tests can exercise non-owner roles (e.g. ?test=1&role=fulfillment).
 */
export function getTestAuthBypass() {
  // Demo-Build (VITE_DEMO=1): Auth kommt aus dem In-Page-Mock (src/demo). Im normalen
  // Build ist die Bedingung statisch false → Zweig wird entfernt.
  if (import.meta.env.VITE_DEMO === '1') return globalThis.__boothlyDemo?.auth?.() ?? null;
  if (!import.meta.env.DEV) return null;
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  if (params.get('test') !== '1') return null;
  const role = params.get('role') || 'owner';
  return {
    user: {
      id: 'test-user-1',
      email: 'test@boothly.local',
    },
    stores: [
      { id: 'test-store-online', name: 'Memorica',     type: 'online', role },
      { id: 'test-store-flea',   name: 'Trödelmarkt',  type: 'flea',   role },
    ],
  };
}
